export default __webpack_public_path__ + "static/media/logo-ford-mid_south-blue.919a8c13.png";